import { STATUSES as SALE_STATUSES } from '../constanst';

const styles = theme => ({
  stepCircle: {
    color: 'white',
    width: '16px',
    height: '16px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  notDoneStep: {
    border: '4px solid rgba(235,238,241, 1)'
  },
  notDoneColor: {
    backgroundColor: 'rgba(235,238,241, 1)'
  },
  endCircles: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  lastCircle: {
    position: 'relative',
    left: '3px'
  },
  [SALE_STATUSES.REGISTERED]: {
    backgroundColor: '#FEB00B'
  },
  [SALE_STATUSES.PENDING_DELIVERY]: {
    backgroundColor: '#FEB00B'
  },
  [SALE_STATUSES.PREAPPROVED]: {
    backgroundColor: '#FEB00B'
  },
  [SALE_STATUSES.PENDING_REVISION]: {
    backgroundColor: '#FEB00B'
  },
  pendingRevisionStatus: {
    border: '4px solid #FEB00B'
  },
  [SALE_STATUSES.DELIVERED]: {
    backgroundColor: '#00C396'
  },
  [SALE_STATUSES.EXCEPTION]: {
    backgroundColor: '#DB4945'
  },
  [SALE_STATUSES.REVOKED]: {
    backgroundColor: '#DB4945'
  },
  [SALE_STATUSES.RETURNED]: {
    backgroundColor: '#DB4945'
  },
  revokedColor: {
    backgroundColor: '#DB4945'
  }
});

export default styles;
